<template>
  <section>
    <div class="flex">
      <div
        :id="`quantity-selector-${id}-decrement`"
        @click="stepUpDown(-1)"
        class="bg-base-secondary w-12 cursor-pointer rounded text-center font-semibold"
      >
        -
      </div>
      <div>
        <input
          :id="`quantity-selector-${id}-value`"
          ref="quantityValue"
          type="number"
          min="0"
          max="99"
          step="1"
          class="bg-transparent w-10 text-center"
          v-model="quantity"
        />
      </div>
      <div
        :id="`quantity-selector-${id}-increment`"
        @click="stepUpDown(1)"
        class="bg-base-secondary w-12 cursor-pointer rounded text-center font-semibold"
      >
        +
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup>
defineProps<{ id: number }>()
const quantity = defineModel<number>({ required: true })
const stepUpDown = (increment: number) => (quantity.value += increment)
</script>
<style scoped>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  opacity: 0;
}
</style>
